import React from 'react';

import { useInView } from '../../hooks/useInView';
import type { Intro } from './slides';

import './IntroSection.css';

type IntroSectionProps = {
    data: Intro;
};

export function IntroSection({ data }: IntroSectionProps) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="fa-intro">
            <div
                ref={ref}
                className={`fa-intro__inner faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
            >
                <span className="fa-intro__badge faves-eyebrow--small faves-glass faves-reveal">{data.badge}</span>
                <h2
                    className="fa-intro__heading faves-display faves-reveal"
                    style={{ '--reveal-delay': '200ms' } as React.CSSProperties}
                >
                    {data.heading}
                </h2>
            </div>
        </section>
    );
}
